import PubSub from "pubsub-js";

export const handleStatus411 = () => {
  PubSub.publish("GlobalRecaptcha", { visible: true });
};

export const handleSearchFeture = () => {
  PubSub.publish("updateSearchFeature", true);
};

export const triggerForyouFirstIn = () => {
  PubSub.publish("ForyouFirstIn", true);
};

export const triggerOpenNewGuildStep = () => {
  PubSub.publish("OpenNewGuildStep", true);
};

export const laterInformationModal = () => {
  PubSub.publish("LaterInformation", true);
};

export const handleSubscriptionChange = () => {
  PubSub.publish("SubscriptionChange", true);
};

export const handleGlobalRecaptchaSuccess = () => {
  PubSub.publish("GlobalRecaptchaSuccess", true);
};

export const handleLanguageChange = (language: string) => {
  PubSub.publish("LanguageChange", language);
};
export const handleAmzLanguageChange = (language: string) => {
  PubSub.publish("AmzLanguageChange", language);
};
export const handleLoginStatus1302 = () => {
  PubSub.publish("LoginStatus1302", true);
};
